export const back_icon = `
<svg width="512pt" height="512pt" version="1.0" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
<g transform="translate(0 512) scale(.1 -.1)">
<path d="m3515 5100c-44-18-189-159-1228-1197-952-951-1184-1188-1203-1228-18-37-24-67-24-115 0-132-74-50 1223-1346 1123-1123 1174-1173 1230-1193 73-27 131-27 204 1 48 17 77 40 174 137 144 143 163 177 164 286 0 58-5 91-19 120-13 27-333 355-995 1018l-976 977 977 978c537 537 984 993 994 1012 9 19 19 67 22 106 7 110-20 160-166 305-98 97-127 119-175 137-71 27-136 27-202 2z"/>
</g>
</svg>
`
